import React, {useContext, useState} from 'react';
import {migrateSender} from '../../services';
import PropTypes from 'prop-types';
import {Col, Label, Row} from "reactstrap";
import {RefreshContext} from "../../Elements/Fetch";
import FormWithActions from "../../Elements/FormWithActions/FormWithActions";
import FormGroupRowText from "../../Elements/FormGroupRowText";
import FormGroupRowCheckbox from "../../Elements/FormGroupRowCheckbox";
import Select from "react-select";

const availablePaymentMethods = [
    'bancontact',
    'payconiq',
    'ideal',
    'digicash',
    'maestro',
    'visa',
    'mastercard',
    'cartebancaire',
    'cartebleuevisa',
    'payByBank',
    'applepay',
    'paypal',
];

const SenderMigrationForm = ({sender, onSubmit}) => {
    const {triggerRefresh} = useContext(RefreshContext);

    const paymentFlowCodeSetting = sender.partnerSettings.find(setting => setting.name === 'paymentFlow.code');
    const [paymentFlowCode, setPaymentFlowCode] = useState(paymentFlowCodeSetting?.value || '');
    const [email, setEmail] = useState(sender.email || '');
    const [addressLine, setAddressLine] = useState(sender.addressLine || '');
    const [vatNumber, setVatNumber] = useState(sender.vatNumber || '');

    const partnerSettingPayDirectlyPaymentMethods = sender.partnerSettings.find(setting => setting.name === 'pay-directly.paymentMethods');
    const [payDirectlyPaymentMethods, setPayDirectlyPaymentMethods] = useState(partnerSettingPayDirectlyPaymentMethods?.value.split(',')
        .filter(method => availablePaymentMethods.includes(method))
        .sort((a, b) => availablePaymentMethods.indexOf(a) - availablePaymentMethods.indexOf(b)) || []);

    const partnerSettingPaymentOptions = sender.partnerSettings.find(setting => setting.name === 'paypage.paymentOptions');
    const [hasPayOnceBC, setHasPayOnceBC] = useState(partnerSettingPaymentOptions?.value.split(',').includes('pay-once-bc') || false);

    const handleAction = async () => {
        const params = {
            paymentFlowCode: paymentFlowCode,
            vatNumber: vatNumber,
            email: email,
            addressLine: addressLine,
            payDirectlyPaymentMethods: payDirectlyPaymentMethods,
            hasPayOnceBC: hasPayOnceBC
        }

        const data = await migrateSender(sender.id, params)
        triggerRefresh(`sender:${sender.id}`)
        onSubmit()

        return data
    }

    const handlePaste = (event) => {
        let clipboardData = event.clipboardData.getData('Text').trim();
        if (clipboardData.includes("\t") && clipboardData.split("\t").length > 7) {
            event.preventDefault();

            // we are only interested in the first non-empty line
            if (clipboardData.includes("\n")) {
                clipboardData = clipboardData.split("\n").filter((line) => line.trim().length > 0)[0];
            }
            if (clipboardData.includes("\r")) {
                clipboardData = clipboardData.split("\r").filter((line) => line.trim().length > 0)[0];
            }
            const lineData = clipboardData.split("\t")
            setPaymentFlowCode(lineData[0])
            setAddressLine(lineData[4])
            setVatNumber(lineData[5])
            setEmail(lineData[7])
        }
    }

    return (
        <>
            <Row>
                <Col>
                    <h1 className="mb-5">
                        Migrate Sender
                    </h1>
                </Col>
            </Row>
            <FormWithActions onAction={handleAction} submitButton="Migrate">

                <FormGroupRowText
                    label="Payment Flow Code"
                    value={paymentFlowCode}
                    onChange={setPaymentFlowCode}
                    onPaste={handlePaste}
                />

                <FormGroupRowText
                    label="Vat Number"
                    value={vatNumber}
                    onChange={setVatNumber}
                    onPaste={handlePaste}
                />

                <FormGroupRowText
                    label="Email"
                    value={email}
                    onChange={setEmail}
                    onPaste={handlePaste}
                />

                <FormGroupRowText
                    label="Address"
                    value={addressLine}
                    onChange={setAddressLine}
                    onPaste={handlePaste}
                />

                <Row form className="form-group">
                    <Col xs="3">
                        <Label className="col-form-label">Payment Methods</Label>
                    </Col>
                    <Col>
                        <Select
                            value={payDirectlyPaymentMethods.map(method => ({value: method, label: method}))}
                            onChange={newSelectedMethods => {
                                setPayDirectlyPaymentMethods(newSelectedMethods
                                    .map(method => method.value)
                                    .sort((a, b) => availablePaymentMethods.indexOf(a) - availablePaymentMethods.indexOf(b))
                                );
                            }}
                            options={availablePaymentMethods.map(method => ({value: method, label: method}))}
                            multi
                            clearable={false}
                        />
                    </Col>
                </Row>

                <FormGroupRowCheckbox
                    label="Bancontact POD"
                    checked={hasPayOnceBC}
                    onChange={setHasPayOnceBC}
                />

            </FormWithActions>
        </>
    );

}

SenderMigrationForm.propTypes = {
    sender: PropTypes.shape({
        id: PropTypes.number.isRequired,
        email: PropTypes.string,
        addressLine: PropTypes.string,
        vatNumber: PropTypes.string,
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default SenderMigrationForm;